import FormErrors from '@/models/form-errors';
import cloneDeep from 'lodash/cloneDeep';
import { reactive } from 'vue';

export function useForm(modelBase) {
  const base = reactive(cloneDeep(modelBase));
  const original = reactive(cloneDeep(modelBase));
  const $ = reactive(cloneDeep(modelBase));
  const $e = reactive(new FormErrors());

  /**
   * Determine if the model is dirty.
   * @returns {boolean}
   */
  function isDirty() {
    return !deepEqual($, original);
  }

  /**
   * Update original model base
   * @param obj
   */
  function updateOriginal(obj) {
    Object.assign(original, cloneDeep(obj));
  }

  return {
    base,
    original,
    $,
    $e,
    isDirty,
    updateOriginal,
  };
}

/**
 * Check if objects are equal
 * @param x
 * @param y
 * @returns {false|boolean|boolean}
 */
function deepEqual(x, y) {
  return (x && y && typeof x === 'object' && typeof y === 'object') ?
    (Object.keys(x).length === Object.keys(y).length) &&
    Object.keys(x).reduce((isEqual, key) => isEqual && deepEqual(x[key], y[key]), true) : (x === y);
}
